import $ from './window-jquery';


export default class LoginState {

	constructor () {
		this.ON_LOGIN 	= typeof Symbol === 'undefined' ? 'ON_LOGIN' : Symbol('ON_LOGIN');
		this.ON_LOGOUT 	= typeof Symbol === 'undefined' ? 'ON_LOGOUT' :  Symbol('ON_LOGOUT');

		this.listeners = new Map();
		this.listeners.set(this.ON_LOGIN, []);
		this.listeners.set(this.ON_LOGOUT, []);

		this.watchEvent();
	}

	getListener(key) {
		return this.listeners.get(key);
	}

	onLogin(callback) {
		this.getListener(this.ON_LOGIN).push(callback)
	}

	onLogout(callback) {
		this.getListener(this.ON_LOGOUT).push(callback)
	}

	watchEvent() {
		let body = $('body');

		body.on('isLogin', (info) => {
			this.getListener(this.ON_LOGIN).forEach((callback) => {
				callback(info);
			})
		});

		body.on('isLogout', (info) => {
			this.getListener(this.ON_LOGOUT).forEach((callback) => {
				callback(info);
			})
		});
	}


}


/** WEBPACK FOOTER **
 ** ./main/assets/article/js/src/login-watcher.js
 **/